import { Link } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="page-spinner" style={{ flexDirection: 'column', gap: '1rem' }}>
      <FileQuestion size={48} color="#94a3b8" />
      <h2 style={{ fontSize: '1.25rem', fontWeight: 600, color: '#1e293b' }}>Page not found</h2>
      <Link className="btn btn-primary" to="/">
        Back to dashboard
      </Link>
    </div>
  );
}
